import React from "react";
import { renderBoldText } from "../utils/helper";
import SourceDialog from "./SourceDialog";
import { useGlobalModalContext } from "../context/GlobalModalContext";
import ReactMarkdown from "react-markdown";
import SentimentFlag from "./SentimentFlag";

function Signals({ signals, height, industryInsights = false }) {
  const { showModal } = useGlobalModalContext();
  const handleSourceClick = (metadata) => {
    showModal(<SourceDialog metadata={metadata} />);
  };
  return (
    <div className="bg-white  ml-8 text-xs">
      {industryInsights ? (
        "Work in progress"
      ) : (
        <>
          {/* <h2 className="text-lg font-bold mb-2 text-main">SIGNALS</h2> */}
          {/* {signals.heading && <div className="text-xs pb-2">{signals.heading}</div>} */}
          <ul
            className={height ? "overflow-y-scroll pb-4" : ""}
            style={{ maxHeight: height }}
          >
            {signals?.description?.map((item, index) => (
              <li key={index} className="pb-4">
                <div
                  className="text-xs border rounded p-2"
                  style={{
                    borderColor: "#A6A6A6",
                    // borderLeft: `4px solid ${
                    //   item?.sentiment_flag?.toLowerCase() === "positive"
                    //     ? "#4CAF50"
                    //     : item?.sentiment_flag?.toLowerCase() === "negative"
                    //     ? "#F15A23"
                    //     : "#A6A6A6"
                    // }`,
                  }}
                >
                  <div>
                    {item.title && (
                      <span className="font-bold">{item.title} : </span>
                    )}
                  </div>
                  <div className="px-2">
                    <ReactMarkdown>{item.text}</ReactMarkdown>
                  </div>

                  <div
                    className="text-right"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleSourceClick(item.metadata)}
                  >
                    <u>
                      <i>Source {item.source_name}</i>
                    </u>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}

export default Signals;
